import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ViewTile } from '@ddv/dashboards';
import { InitializationErrorCollectorService } from '@ddv/navigation';
import { DashboardNavService } from '@ddv/views';
import { catchError, Observable, of } from 'rxjs';

export const viewTilesResolver: ResolveFn<ViewTile[]> = (route): Observable<ViewTile[]> => {
    const errorCollector = inject(InitializationErrorCollectorService);
    const service = inject(DashboardNavService);

    const clientCode = route.paramMap.get('clientCode') ?? '';
    // Right now this only forces an early call to fetch view tiles. After we remove the MW,
    // we can think of passing the view tiles to the left-nav component via inputs and
    // handle them better there
    return service.fetchOpenViewTiles(clientCode)
        .pipe(catchError((error) => {
            errorCollector.addError(`Failed to load view tiles for client ${clientCode}`, error);
            return of([]);
        }));
};

